//messages.js
export default {
    // INVOICES
    invoice_id: "Invoice #",
    invoice_date: "Invoice Date",
    due_date: "Due Date",
    edit_fe_invoice: "Edit Invoice",
    add_fe_invoice: "Add Invoice",
    delete_fe_invoice: "Delete Invoice",
    delete_invoice_confirm: "This action is not reversible!",
    fe_invoices: "Invoices",
    fe_invoice: "Invoice",
    delete_fe_invoice_confirm: "This action is not reversible!",

    invoice_detail_id: "ID",
    edit_fe_invoice_detail: "Edit Invoice Detail",
    add_fe_invoice_detail: "Add Invoice Detail",
    delete_fe_invoice_detail: "Delete Invoice Detail",
    fe_invoice_details: "Invoice Details",
    expedite_fee: "Expedite Fee",
    handling_charge: "Handling Charge",

    payment_id: "Payment",
    invoice_id: "Invoice",
    payment_term_id: "Payment Term",
    payment_date: "Payment Date",
    reference_num: "Reference Num",
    currency_id: "Currency",
    document_currency: "Document Currency",
    exchange_rate: "Exchange Rate",
    account_id: "Account",
    status_id: "Status",
    notes: "Notes",
    edit_fe_invoice_payment: "Edit Payment",
    add_fe_invoice_payment: "Receive Payment",
    delete_fe_invoice_payment: "Delete Payment",
    fe_invoice_payments: "Invoice Payments",
    delete_fe_invoice_payment_confirm: "This action is not reversible!",
    payment_larger_than_balance: "Payment amount is larger than the balance.",
    bank_account: "Bank Account",
};
